import { LocalService } from './local';
import { SessionService } from './session';
import { STORAGE_TYPE } from './storage.enum';

export const storageMap: any = new Map<STORAGE_TYPE, any>().set(STORAGE_TYPE.LOCAL, LocalService).set(STORAGE_TYPE.SESSION, SessionService);
